// ** Reactstrap Imports
import { Edit2, MoreVertical, Trash2 } from 'react-feather';
import {
  Badge,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown
} from 'reactstrap';

const statusObj = {
  activo: 'light-success',
  inactivo: 'light-secondary'
};

export const columns = ({ handleDelete, handleUpdate }) => [
  {
    name: 'PORTADA',
    sortable: false,
    maxWidth: '150px',
    selector: (row) => row.cover,
    cell: (row) => <img width={45} height={45} src={row.cover} />
  },
  {
    name: 'NOMBRE DEL LOGRO',
    sortable: true,
    minWidth: '300px',
    sortField: 'title',
    selector: (row) => row.title,
    cell: (row) => (
      <div className="d-flex justify-content-left align-items-center">
        <div className="d-flex flex-column">
          <span className="fw-bolder">{row.title}</span>
        </div>
      </div>
    )
  },
  {
    name: 'META',
    maxWidth: '250px',
    sortable: true,
    sortField: 'quantity',
    selector: (row) => row.quantity,
    cell: (row) => (
      <span className="text-capitalize" style={{ padding: '10px' }}>
        {row.quantity}
      </span>
    )
  },
  {
    name: 'ALCANZADO',
    minWidth: '250px',
    sortable: true,
    sortField: 'reached',
    selector: (row) => row.reached,
    cell: (row) => (
      <span
        className="text-capitalize width-100 d-flex justify-content-center"
        style={{ paddingRight: '10px' }}
      >
        {row.reached}
      </span>
    )
  },
  {
    name: 'Estado',
    minWidth: '195px',
    sortable: false,
    sortField: 'status',
    selector: (row) => row.status,
    cell: (row) => (
      <Badge
        className="text-capitalize"
        color={row.status ? statusObj.activo : statusObj.inactivo}
        pill
      >
        {row.status ? 'Activo' : 'Inactivo'}
      </Badge>
    )
  },
  {
    name: '',
    minWidth: '50px',
    cell: (row) => (
      <div className="column-action">
        <UncontrolledDropdown>
          <DropdownToggle tag="div" className="btn btn-sm">
            <MoreVertical size={14} className="cursor-pointer" />
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem
              tag="a"
              href="/"
              className="w-100"
              onClick={(e) => handleUpdate({ e, row })}
            >
              <Edit2 size={14} className="me-50" />
              <span className="align-middle">Editar</span>
            </DropdownItem>
            <DropdownItem
              tag="a"
              href="/"
              className="w-100"
              onClick={(e) => handleDelete({ e, id: row._id })}
            >
              <Trash2 size={14} className="me-50" />
              <span className="align-middle">Eliminar</span>
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </div>
    )
  }
];
